// src/services/wholesaleRequests.api.js
import { apiRequest } from "./api";

export const submitWholesaleRequest = (data) => {
  return apiRequest("/wholesale-requests", {
    method: "POST",
    body: JSON.stringify(data),
  });
};